/** @format */

import { useCallback, useEffect, useState } from "react";
import { AiFillHeart, AiFillMessage, AiFillShopping } from "react-icons/ai";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { io } from "socket.io-client";
import api from "../api/api";

// utils/utils.jsx

import { useDispatch, useSelector } from "react-redux";
import { get_orders } from "../store/reducers/orderReducer";

import toast from "react-hot-toast";

export const overrideStyle = {
  display: "flex",
  margin: "0 auto",
  height: "24px",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
};

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

export const socket = io.connect(`${process.env.REACT_APP_SERVER_URL}`);

export const trackEvent = async (type, product) => {
  try {
    await api.post(`${process.env.REACT_APP_SERVER_URL}/api/product/event`, {
      productId: product._id,
      sellerId: product.sellerId,
      type,
    });
  } catch (err) {
    console.log("Tracking error:", err.message);
  }
};

export const track = (type, product) => {
  navigator.sendBeacon(
    "/api/product/event",
    JSON.stringify({
      productId: product._id,
      sellerId: product.sellerId,
      type,
    }),
  );
};

export const socialLinks = [
  {
    icon: <FaFacebookF />,
    label: "Facebook",
    href: "https://www.facebook.com/@gobymall",
  },
  {
    icon: <FaTiktok />,
    label: "TikTok",
    href: "https://www.tiktok.com/@gobymall",
  },
  {
    icon: <FaInstagram />,
    label: "Instagram",
    href: "https://www.instagram.com/gobymall",
  },
  {
    icon: <FaLinkedinIn />,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/gobymall",
  },
];

//export const phone = "22870488166";
export const phone = "22893794182";
export const email = "magnoudewagobymall2024@gmail.com";
export const address = "Lomé, Togo";

export const devise = "CFA";

export const Background = ({ t }) => {
  return (
    <section
      style={{
        backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}/images/gifs/shop.gif')`,
      }}
      className='h-[100px] sm:hidden mt-6 bg-no-repeat relative bg-left bg-cover select-none'
    >
      <div className='absolute left-0 top-0 w-full h-full bg-blue-800/30'>
        <div className='w-[80%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto '>
          <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
            <h1 className='text-3xl font-bold rounded-full'>{t("Shop")}</h1>
            <div className='flex gap-2 items-center justify-center text-2xl w-full '>
              <Link to='/' className='rounded-full'>
                {t("Home")}
              </Link>
              <span className='pt-1'>
                <MdOutlineKeyboardArrowRight />
              </span>
              <span>{t("Products")}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export function TruncateText({ text, maxLength }) {
  if (text?.length <= maxLength) {
    return <span>{text}</span>;
  }
  const truncatedText = text?.substring(0, maxLength) + "...";
  return <span>{truncatedText}</span>;
}

export const WishCardMessage = ({
  redirect_to_wishlist_page,
  wishList_count,
  redirect_to_card_page,
  card_total,
  footer,
  redirect_to_chat_page,
  totalCustommerUnread,
}) => {
  return (
    <div
      className={`flex gap-6 my-6 ${footer ? `w-full h-full flex gap-2 flex-col justify-center items-center ` : ""}`}
    >
      <div
        onClick={redirect_to_wishlist_page}
        className='relative w-[35px] h-[35px] bg-[#e2e2e2] rounded-full flex justify-center items-center cursor-pointer'
      >
        <AiFillHeart className='text-red-500' />
        {wishList_count !== 0 && (
          <div className='absolute -top-1 -right-1 w-5 h-5 bg-green-500 text-white text-xs rounded-full flex justify-center items-center'>
            {wishList_count}
          </div>
        )}
      </div>

      <div
        onClick={redirect_to_card_page}
        className='relative w-[35px] h-[35px] bg-[#e2e2e2] rounded-full flex justify-center items-center cursor-pointer'
      >
        <AiFillShopping className='text-blue-500' />
        {card_total !== 0 && (
          <div className='absolute -top-1 -right-4 h-5 px-2 bg-orange-500 text-white text-xs rounded-full flex justify-center items-center'>
            {card_total}
          </div>
        )}
      </div>
      <div
        onClick={redirect_to_chat_page}
        className='relative w-[35px] h-[35px] rounded-full bg-[#e2e2e2] flex justify-center items-center cursor-pointer'
      >
        <AiFillMessage className='text-lime-700' />
        {totalCustommerUnread !== 0 && (
          <div className='absolute -top-[3px] -right-[20px] h-[20px] px-2 bg-blue-300 rounded-full text-white flex justify-center items-center'>
            {totalCustommerUnread}
          </div>
        )}
      </div>
    </div>
  );
};

const generateWhatsAppMessage = (message) => {
  switch (message.messageType) {
    case "image":
      return `Bonjour, je vous contacte concernant des images envoyées sur gobymall.

Message : ${message.message || "Aucun message"}
Nombre d’images : ${message.images?.length || 0}
`;

    case "product": {
      const p = message.productInfo;
      // 🔥 détection variantes
      const hasVariant = p.color || p.size;
      // 🧩 bloc variantes
      const variantDetails = hasVariant
        ? `
Couleur : ${p.color || "-"}
Taille : ${p.size || "-"}`
        : "";
      // 📝 message utilisateur (si existe)
      const userMessage = message.message
        ? `\n Message : ${message.message}\n`
        : "";

      return `Bonjour, je suis intéressé par ce produit :
Produit : ${p.title || p.name}
Prix : ${p.price} ${devise}
Stock : ${p.stock}${variantDetails}

${userMessage}🔗 https://gobymall.com/product/details/${p.productId || p._id}
`;
    }

    case "order": {
      const o = message.orderInfo;

      const productsList = o.products
        .map((p, index) => {
          return `🔹 ${index + 1}. ${p.title}
   Qté : ${p.quantity}
   Prix : ${p.unitPrice} ${devise}
   image : ${p.image}
   🔗 https://gobymall.com/product/details/${p.productId}`;
        })
        .join("\n\n");

      return `Bonjour ${o.shopName},

Je vous contacte concernant ma commande :

Commande #${o.orderId}
Produits commandés :
${productsList}
Total : ${o.totalPrice.toFixed(2)} ${devise}

👉 Merci de me confirmer la disponibilité et les modalités de paiement.
`;
    }

    default:
      return `Bonjour, je vous contacte depuis gobymall :
${message.message}
`;
  }
};
/*
export const WhatsAppButton = ({ sellerPhone, message, buttonName}) => {
  const handleClick = () => {
    const autoMessage = generateWhatsAppMessage(message);

    const msg = encodeURIComponent(autoMessage);

    window.open(`https://wa.me/${sellerPhone}?text=${msg}`, "_blank");
  };

  return (
    <div className='justify-center inline-flex items-center gap-2 px-4 py-2 bg-slate-200 hover:bg-slate-400 text-xs font-semibold rounded-xl transition-colors shadow-sm '>
      <button
        onClick={handleClick}
        className='flex justify-center items-center gap-1.5 text-xs text-green-600 font-medium hover:text-green-700 transition-colors'
      >
        <svg viewBox='0 0 24 24' className='w-3.5 h-3.5 fill-current'>
          <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z' />
          <path d='M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.855L.057 23.885a.5.5 0 00.606.606l6.03-1.471A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.67-.502-5.213-1.381l-.374-.218-3.878.945.962-3.878-.237-.389A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' />
        </svg>

        {buttonName || "Continuer sur WhatsApp"}
      </button>
    </div>
  );
};
*/
export const WhatsAppButton = ({
  sellerPhone,
  message,
  buttonName,
  productId,
  width,
}) => {
  const { trackAction } = useProductTracking(productId);

  const handleClick = () => {
    const autoMessage = generateWhatsAppMessage(message);
    const msg = encodeURIComponent(autoMessage);

    // tracking + ouverture WhatsApp
    trackAction("whatsapp");
    window.open(`https://wa.me/${sellerPhone}?text=${msg}`, "_blank");
  };

  return (
    <div
      className={`justify-center w-${width} inline-flex items-center gap-2 px-4 py-2 bg-slate-200 hover:bg-slate-400 text-xs font-semibold rounded-xl transition-colors shadow-sm`}
    >
      <button
        onClick={handleClick}
        className='flex justify-center items-center gap-1.5 text-xs text-green-600 font-medium hover:text-green-700 transition-colors'
      >
        <svg viewBox='0 0 24 24' className='w-3.5 h-3.5 fill-current'>
          <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z' />
          <path d='M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.855L.057 23.885a.5.5 0 00.606.606l6.03-1.471A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.67-.502-5.213-1.381l-.374-.218-3.878.945.962-3.878-.237-.389A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' />
        </svg>

        {buttonName || "Continuer sur WhatsApp"}
      </button>
    </div>
  );
};

/**
 * Hook réutilisable pour tracker les actions sur un produit.
 *
 * @param {string} productId - L'ID du produit
 * @returns {{ trackAction: Function }}
 *
 * @example
 * const { trackAction } = useProductTracking(product._id);
 * <button onClick={() => trackAction('addToCart')}>Ajouter au panier</button>
 */
export const useProductTracking = (productId) => {
  const trackAction = useCallback(
    async (action) => {
      //console.log("productid", productId);
      if (!productId) return;
      try {
        await api.post(
          `${process.env.REACT_APP_SERVER_URL}/api/home/product/${productId}/track`,
          { action },
        );
      } catch (err) {
        // Silencieux : ne pas bloquer l'UX si le tracking échoue
        console.warn(
          `[tracking] Échec pour l'action "${action}" :`,
          err.message,
        );
      }
    },
    [productId],
  );

  return { trackAction };
};
//////////////////////
/*
const ConfirmButton = ({
  orderId,
  role, // "buyer" | "seller"
  alreadyConfirmed,
  disabled,
  onSuccess,
  customerId,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const url =
        role === "buyer"
          ? `/api/order/confirm/buyer/${orderId}`
          : `/api/order/confirm/seller/${orderId}`;

      const { data } = await api.put(
        url,
        { customerId },
        { withCredentials: true },
      );

      onSuccess && onSuccess(data);
    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.message || "Erreur lors de la confirmation");
    } finally {
      setLoading(false);
    }
  };

  // 🎨 Styles dynamiques Tailwind
  const baseStyle =
    "px-4 py-2 rounded-lg font-semibold transition duration-300";

  const roleStyle =
    role === "buyer"
      ? "bg-green-500 text-white hover:bg-green-600"
      : "bg-blue-500 text-white hover:bg-blue-600";

  const disabledStyle = "bg-gray-300 text-gray-600 cursor-not-allowed";

  return (
    <button
      onClick={handleConfirm}
      disabled={loading || alreadyConfirmed || disabled}
      className={`${baseStyle} ${
        loading || alreadyConfirmed || disabled ? disabledStyle : roleStyle
      }`}
    >
      {loading
        ? "Chargement..."
        : alreadyConfirmed
          ? "Déjà confirmé"
          : role === "buyer"
            ? "Confirmer paiement"
            : "Confirmer réception"}
    </button>
  );
};
*/
/*
export const BuyerSection = ({ order, refreshOrder }) => {
  return (
    <div>
      <ConfirmButton
        orderId={order._id}
        role='buyer'
        alreadyConfirmed={order.buyerConfirmed}
        disabled={order.order_status === "expired"}
        onSuccess={refreshOrder}
        customerId={order.customerId}
      />
    </div>
  );
};
*/
// timer expiration
export const ExpirationTimer = ({ expiresAt }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = new Date(expiresAt) - new Date();

      if (diff <= 0) {
        setTimeLeft("Expiré");
        clearInterval(interval);
      } else {
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff / (1000 * 60)) % 60);

        setTimeLeft(`${hours}h ${minutes}m`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return <span>{timeLeft}</span>;
};

////// ux status commande
export const OrderStatus = ({ order }) => {
  return (
    <div>
      <p>Status: {order.order_status}</p>

      {order.order_status === "expired" && (
        <span style={{ color: "red" }}>Expirée</span>
      )}

      {order.order_status === "paid" && (
        <span style={{ color: "green" }}>Validé</span>
      )}
    </div>
  );
};

const ConfirmButton = ({
  orderId,
  role,
  alreadyConfirmed,
  disabled,
  onSuccess,
  customerId,
}) => {
  const [loading, setLoading] = useState(false);

  //console.log("order id", orderId);

  const handleConfirm = async () => {
    if (alreadyConfirmed || disabled || loading) return;
    try {
      setLoading(true);
      const url =
        role === "buyer"
          ? `/api/order/confirm/buyer/${orderId}`
          : `/api/order/confirm/seller/${orderId}`;

      const { data } = await api.put(url, {}, { withCredentials: true });
      toast.success(data.message || "Confirmation réussie");
      onSuccess && onSuccess(data);
    } catch (error) {
      const msg =
        error?.response?.data?.message || "Erreur lors de la confirmation";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (alreadyConfirmed) {
    return (
      <span className='inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'>
        <svg className='w-3 h-3' fill='currentColor' viewBox='0 0 20 20'>
          <path
            fillRule='evenodd'
            d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
            clipRule='evenodd'
          />
        </svg>
        Confirmé
      </span>
    );
  }

  return (
    <button
      onClick={handleConfirm}
      disabled={loading || disabled}
      className={`
        px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-200
        ${
          disabled
            ? "bg-slate-100 text-slate-400 cursor-not-allowed"
            : role === "buyer"
              ? "bg-emerald-500 hover:bg-emerald-600 text-white active:scale-95"
              : "bg-blue-500 hover:bg-blue-600 text-white active:scale-95"
        }
      `}
    >
      {loading
        ? "..."
        : role === "buyer"
          ? "Confirmer paiement"
          : "Confirmer reception"}
    </button>
  );
};

export const BuyerSection = ({ order }) => {
  const dispatch = useDispatch();
  const { customerInfo } = useSelector((state) => state.auth);

  const handleSuccess = () => {
    // Rafraîchit la liste après confirmation
    dispatch(
      get_orders({
        status: "all",
        customerId: customerInfo.id,
        pageNumber: 1,
      }),
    );
  };

  return (
    <ConfirmButton
      orderId={order._id || order.orderId}
      role='buyer'
      alreadyConfirmed={order.buyerConfirmed}
      disabled={
        order.order_status === "expired" || order.order_status === "paid"
      }
      onSuccess={handleSuccess}
    />
  );
};
